// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { deviceModelId } from './DeviceModel';
import { z } from 'zod';
export const deviceModelAffordanceId = (z.number());
export const deviceModelAffordance = z.object({
    id: deviceModelAffordanceId,
    device_model_id: deviceModelId,
    affordance_id: z.string(),
    type: z.string(),
    refs: z.unknown(),
    params: z.unknown(),
    group_label: z.string().nullable(),
    sort_order: z.number().nullable(),
    size: z.string().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    visible_when: z.unknown().nullable(),
    controlled_when: z.unknown().nullable(),
});
export const deviceModelAffordanceInitializer = z.object({
    id: deviceModelAffordanceId.optional(),
    device_model_id: deviceModelId,
    affordance_id: z.string(),
    type: z.string(),
    refs: z.unknown().optional(),
    params: z.unknown().optional(),
    group_label: z.string().optional().nullable(),
    sort_order: z.number().optional().nullable(),
    size: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    visible_when: z.unknown().optional().nullable(),
    controlled_when: z.unknown().optional().nullable(),
});
export const deviceModelAffordanceMutator = z.object({
    id: deviceModelAffordanceId.optional(),
    device_model_id: deviceModelId.optional(),
    affordance_id: z.string().optional(),
    type: z.string().optional(),
    refs: z.unknown().optional(),
    params: z.unknown().optional(),
    group_label: z.string().optional().nullable(),
    sort_order: z.number().optional().nullable(),
    size: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    visible_when: z.unknown().optional().nullable(),
    controlled_when: z.unknown().optional().nullable(),
});
//# sourceMappingURL=DeviceModelAffordance.js.map